//领书申请列表
export const ACTION_BOOK_COLLECTION_STATEMENT_LIST = 'ACTION_BOOK_COLLECTION_STATEMENT_LIST';
//领书申请教材详情列表
export const ACTION_BOOK_COLLECTION_DETAIL_STATEMENT_LIST = 'ACTION_BOOK_COLLECTION_DETAIL_STATEMENT_LIST';


// WEBPACK FOOTER //
// ./src/store/Admin/modules/bookCollection/types.js